import './chosen.image-select';

export default class Chosen {

  constructor(initPickers = false) {
    const chosenSelectors = document.querySelectorAll('.chosen-select');
    const chosenImgSelectors = document.querySelectorAll('.chosen-image-select');
    const chosenGridSelectors = document.querySelectorAll('.chosen-grid-select');
    const chosenGridSmallSelectors = document.querySelectorAll('.chosen-grid-small');

    const self = this;

    if (!initPickers) {
      return;
    }

    if (chosenSelectors.length) {
      chosenSelectors.forEach(select => {
        const chosen = $(select);
        self.initializeChosen(chosen);
      });
    }

    if (chosenImgSelectors.length) {
      chosenImgSelectors.forEach(select => {
        const chosen = $(select);
        self.initChosenImage(chosen);
      });
    }

    if (chosenGridSelectors.length) {
      chosenGridSelectors.forEach(select => {
        const chosen = $(select);
        self.initChosenGridSelect(chosen);
      });
    }

    if (chosenGridSmallSelectors.length) {
      chosenGridSmallSelectors.forEach(select => {
        const chosen = $(select);
        self.initChosenGridSmall(chosen);
      });
    }
  }

  initializeChosen(select) {
    select.chosen({
      disable_search_threshold: 10,
      search_contains: false,
      width: '98%',
    });
  }

  initChosenImage(select) {
    select.chosen({
      disable_search_threshold: 10,
      search_contains: false,
      width: '98%',
    });
    $('.chosen-image-select').next().addClass('chosen-container-img');
    $('.chosen-image-select.org-selector').next().addClass('chosen-container-orgs');
    $('.chosen-image-select.org-billing-selector').next().addClass('chosen-container-billing-orgs');
  }
  initChosenGridSelect(select) {
    select.chosen({
      search_contains: false,
      width: '96%',
    });

    select
      .next()
      .children('.chosen-single')
      .addClass(`${ select.data('entity') }-icon`);
  }
  initChosenGridSmall(select) {
    select.chosen({
      search_contains: false,
      width: '45%',
    });
  }
}
